import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TimelineModalFilterService } from '../../services/timeline-modal-filter.service';

@Component({
  selector: 'wilson-grouped-activity-staff-status-filter',
  templateUrl: './grouped-activity-staff-status-filter.component.html',
  styleUrls: ['./grouped-activity-staff-status-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GroupedActivityStaffStatusFilterComponent {
  timelineModalFilterService = inject(TimelineModalFilterService);
}
